import React from "react";
import "../../styles/sections/financingCard.scss";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";

const FinancingCard = ({
  banco,
  logo,
  color,
  etiquetas,
  titulo,
  tasa,
  tasaDestacada,
  detalle,
  detalleDestacado,
  link,
}) => {
  const { openConsultaForm, loading } = useWhatsAppConsulta();

  const handleConsultarFinanciacion = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "consultar",
      seccion: "financiacion",
      banco: banco || undefined,
    });
    openConsultaForm();
  };

  return (
    <div className="financing-card">
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        {logo && <img src={logo} alt={banco} className="financing-card-logo" />}
      </div>
      <div className="financing-chips-container" style={{ marginBottom: 12 }}>
        {etiquetas &&
          etiquetas.map((et, i) => (
            <span key={i} className="financing-chip">
              {et}
            </span>
          ))}
        {tasaDestacada && <span className="financing-chip tasa">{tasaDestacada}</span>}
      </div>
      <div style={{ marginBottom: 12, marginTop: 12 }}>
        <p className="financing-card-title">
          {titulo}{" "}
          {tasa && (
            <span className="financing-card-tasa">
              {tasa} {detalle && <span className="financing-card-detalle">{detalle}</span>}
            </span>
          )}
        </p>
        {detalleDestacado && <div className="financing-card-detalle-destacado">{detalleDestacado}</div>}
      </div>
      <div>
        <button onClick={handleConsultarFinanciacion} className="financing-card-btn" disabled={loading}>
          Consultá ahora <span>→</span>
        </button>
      </div>
    </div>
  );
};

export default FinancingCard;
